import type { CreateClientConfig } from '../generated/korza-api-client/client';
import type { ClientOptions as ClientOptions2 } from '../generated/korza-api-client/types.gen';

export const createClientConfig: CreateClientConfig<ClientOptions2> = (
  override
) => ({
  baseUrl: import.meta.env.VITE_PUBLIC_API_BASE_URL ?? 'http://localhost:3000',
  credentials: 'include',
  ...override,
});
